import React, { useEffect } from "react";
import Nav from "@/components/site/Nav";
import Hero from "@/components/site/Hero";
import WhatIDo from "@/components/site/WhatIDo";
import WhyItMatters from "@/components/site/WhyItMatters";
import WhatICreate from "@/components/site/WhatICreate";
import Services from "@/components/site/Services";
import Process from "@/components/site/Process";
import SetsApart from "@/components/site/SetsApart";
import WhoFor from "@/components/site/WhoFor";
import Portfolio from "@/components/site/Portfolio";
import About from "@/components/site/About";
import Contact from "@/components/site/Contact";
import Footer from "@/components/site/Footer";
import { trackEvent } from "@/lib/api";

export default function Home() {
    useEffect(() => {
        trackEvent("page_view", "home");

        const sectionIds = [
            "what-i-do",
            "why-it-matters",
            "what-i-create",
            "services",
            "process",
            "sets-apart",
            "who-for",
            "portfolio",
            "about",
            "contact",
        ];
        const tracked = new Set();
        const obs = new IntersectionObserver(
            (entries) => {
                entries.forEach((entry) => {
                    if (entry.isIntersecting && !tracked.has(entry.target.id)) {
                        tracked.add(entry.target.id);
                        trackEvent("section_view", entry.target.id);
                    }
                });
            },
            { threshold: 0.35 }
        );
        sectionIds.forEach((id) => {
            const el = document.getElementById(id);
            if (el) obs.observe(el);
        });
        return () => obs.disconnect();
    }, []);

    return (
        <div className="App grain min-h-screen">
            <Nav />
            <main>
                <Hero />
                <WhatIDo />
                <WhyItMatters />
                <WhatICreate />
                <Services />
                <Process />
                <SetsApart />
                <WhoFor />
                <Portfolio />
                <About />
                <Contact />
            </main>
            <Footer />
        </div>
    );
}
